import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClick", "text", "className", "iconName"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { Button as SemanticUiButton } from 'semantic-ui-react';
import { classNames } from '../../../../../../utils/classname';
import Icon from '../../../../../foundation/components/Icon';
import useSemanticUiProps from '../../../../../foundation/hooks/use-semantic-ui-props';
import './MoreInfoButton.css';
var defaultProps = {
  className: '',
  iconName: 'info circle'
};
export default function MoreInfoButton(_ref) {
  var onClick = _ref.onClick,
    text = _ref.text,
    className = _ref.className,
    iconName = _ref.iconName,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!onClick) {
    return null;
  }
  var _useSemanticUiProps = useSemanticUiProps(),
    getButtonProps = _useSemanticUiProps.getButtonProps;
  var finalClassName = classNames(_defineProperty({
    'more-info-button': true
  }, className, true));
  return /*#__PURE__*/React.createElement(SemanticUiButton, _extends({
    className: finalClassName,
    "aria-label": "More Info"
  }, getButtonProps(_objectSpread({
    content: text,
    onClick: onClick
  }, rest)), {
    icon: true
  }), /*#__PURE__*/React.createElement(Icon, {
    iconName: iconName
  }));
}
MoreInfoButton.defaultProps = defaultProps;